// Kommandopalett (⌘K / Ctrl-K) — den primære, tastatur-først interaksjonen
// (à la Linear/Raycast/Superhuman). Fuzzy-søk over alle handlinger + go-to
// (koordinat/enhet). Åpnes med ⌘K, lukkes med Esc. Pilnav + Enter.
export interface Command {
  id: string;
  title: string;
  hint?: string; // høyre side (snarvei/kategori)
  keywords?: string;
  run: () => void;
}

export class CommandPalette {
  private overlay: HTMLElement;
  private input: HTMLInputElement;
  private list: HTMLElement;
  private items: Command[] = [];
  private filtered: Command[] = [];
  private sel = 0;
  private extra?: (q: string) => Command[];

  constructor(commands: Command[], dynamic?: (q: string) => Command[]) {
    this.items = commands;
    this.extra = dynamic;
    this.overlay = div('cmdk-overlay');
    const box = div('cmdk-box');
    this.input = document.createElement('input');
    this.input.className = 'cmdk-input';
    this.input.placeholder = 'Søk kommando eller koordinat…  (⌘K)';
    this.input.autocomplete = 'off';
    this.list = div('cmdk-list');
    box.append(this.input, this.list);
    this.overlay.append(box);
    document.body.append(this.overlay);

    this.overlay.addEventListener('click', (e) => {
      if (e.target === this.overlay) this.close();
    });
    this.input.addEventListener('input', () => this.refilter());
    this.input.addEventListener('keydown', (e) => this.onKey(e));
  }

  open() {
    this.overlay.classList.add('show');
    this.input.value = '';
    this.refilter();
    this.input.focus();
  }
  close() {
    this.overlay.classList.remove('show');
  }
  toggle() {
    this.overlay.classList.contains('show') ? this.close() : this.open();
  }

  private refilter() {
    const q = this.input.value.trim().toLowerCase();
    const base = this.items.filter((c) =>
      !q || (c.title + ' ' + (c.keywords ?? '')).toLowerCase().includes(q),
    );
    const dyn = q && this.extra ? this.extra(q) : [];
    this.filtered = [...dyn, ...base];
    this.sel = 0;
    this.renderList();
  }

  private renderList() {
    this.list.innerHTML = '';
    if (!this.filtered.length) {
      this.list.innerHTML = '<div class="cmdk-empty">Ingen treff</div>';
      return;
    }
    this.filtered.forEach((c, i) => {
      const row = div('cmdk-row' + (i === this.sel ? ' sel' : ''));
      const t = document.createElement('span');
      t.className = 'cmdk-title';
      t.textContent = c.title;
      row.append(t);
      if (c.hint) {
        const h = document.createElement('span');
        h.className = 'cmdk-hint';
        h.textContent = c.hint;
        row.append(h);
      }
      row.addEventListener('click', () => this.exec(i));
      this.list.append(row);
    });
  }

  private onKey(e: KeyboardEvent) {
    if (e.key === 'Escape') { this.close(); return; }
    if (e.key === 'ArrowDown') { e.preventDefault(); this.sel = Math.min(this.sel + 1, this.filtered.length - 1); this.renderList(); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); this.sel = Math.max(this.sel - 1, 0); this.renderList(); }
    else if (e.key === 'Enter') { e.preventDefault(); this.exec(this.sel); }
  }

  private exec(i: number) {
    const c = this.filtered[i];
    if (!c) return;
    this.close();
    c.run();
  }
}

function div(cls: string): HTMLElement {
  const d = document.createElement('div');
  d.className = cls;
  return d;
}
